var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopilot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "4 2 40 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1423 7.32501C33.5634 5.35387 31.7547 4 29.7003 4L28.3488 4C26.1142 4 24.1985 5.59611 23.7952 7.79398L21.4805 20.4072L22.0549 18.4419C22.6319 16.4679 24.4419 15.1111 26.4986 15.1111H34.3524L37.6462 16.3942L40.8213 15.1111H39.8946C37.8401 15.1111 36.0315 13.7572 35.4525 11.7861L34.1423 7.32501Z",
    fill: "url(#paint0_radial_56201_15503)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3307 40.656C14.9032 42.6366 16.7165 44 18.7783 44H21.6486C24.1592 44 26.2122 41.999 26.2767 39.4893L26.5893 27.3271L25.9354 29.5602C25.3577 31.5332 23.5481 32.8889 21.4923 32.8889L13.5732 32.8889L10.7499 31.3573L7.69336 32.8889H8.60461C10.6663 32.8889 12.4796 34.2522 13.0521 36.2329L14.3307 40.656Z",
    fill: "url(#paint1_radial_56201_15503)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4993 4H13.46C8.87732 4 6.12772 10.0566 4.29466 16.1132C2.12296 23.2886 -0.718769 32.8852 7.50252 32.8852H14.4282C16.4978 32.8852 18.3147 31.5168 18.8835 29.5269C20.0876 25.3143 22.1978 17.9655 23.8554 12.3712C24.6977 9.52831 25.3993 7.08673 26.4762 5.56628C27.0799 4.71385 28.086 4 29.4993 4Z",
    fill: "url(#paint2_linear_56201_15503)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4993 4H13.46C8.87732 4 6.12772 10.0566 4.29466 16.1132C2.12296 23.2886 -0.718769 32.8852 7.50252 32.8852H14.4282C16.4978 32.8852 18.3147 31.5168 18.8835 29.5269C20.0876 25.3143 22.1978 17.9655 23.8554 12.3712C24.6977 9.52831 25.3993 7.08673 26.4762 5.56628C27.0799 4.71385 28.086 4 29.4993 4Z",
    fill: "url(#paint3_linear_56201_15503)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.498 44H34.5374C39.12 44 41.8696 37.9424 43.7027 31.8848C45.8744 24.7081 48.7161 15.1098 40.4948 15.1098H33.5693C31.4996 15.1098 29.6827 16.4784 29.114 18.4684C27.9098 22.6817 25.7996 30.032 24.142 35.6273C23.2996 38.4708 22.598 40.9127 21.5212 42.4335C20.9175 43.286 19.9113 44 18.498 44Z",
    fill: "url(#paint4_radial_56201_15503)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.498 44H34.5374C39.12 44 41.8696 37.9424 43.7027 31.8848C45.8744 24.7081 48.7161 15.1098 40.4948 15.1098H33.5693C31.4996 15.1098 29.6827 16.4784 29.114 18.4684C27.9098 22.6817 25.7996 30.032 24.142 35.6273C23.2996 38.4708 22.598 40.9127 21.5212 42.4335C20.9175 43.286 19.9113 44 18.498 44Z",
    fill: "url(#paint5_linear_56201_15503)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_56201_15503",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.005 20.5144) rotate(-129.304) scale(17.3033 16.2706)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0955758,
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773185,
    stopColor: "#2253CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0736C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_56201_15503",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.1215 32.8171) rotate(51.84) scale(15.9912 15.5119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633728,
    stopColor: "#FF5F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923392,
    stopColor: "#C02B3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_56201_15503",
    x1: 12.5,
    y1: 7.5,
    x2: 14.7884,
    y2: 33.9751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156162,
    stopColor: "#0D91E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487484,
    stopColor: "#52B471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652394,
    stopColor: "#98BD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937361,
    stopColor: "#FFC800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_56201_15503",
    x1: 14.5,
    y1: 4,
    x2: 15.7496,
    y2: 32.8852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246674,
    stopColor: "#0588F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_56201_15503",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.3187 12.2813) rotate(109.274) scale(38.3873 45.9867)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0661714,
    stopColor: "#8C48FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2598A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#FFB152"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_56201_15503",
    x1: 42.5859,
    y1: 13.346,
    x2: 42.5695,
    y2: 21.2147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581535,
    stopColor: "#F8ADFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708063,
    stopColor: "#A86EDD",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilot);
export default __webpack_public_path__ + "static/media/Copilot.9000a09a5791d1580af633a61206c0e4.svg";
export { ForwardRef as ReactComponent };